const openEnded = {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "open-ended",
    items: [
      { id: "q1", question: "提示的文本 1", answers: [], image: null },
      { id: "q2", question: "提示的文本 2", answers: [], image: null },
      { id: "q3", question: "提示的文本 3", answers: [], image: null },
      { id: "q4", question: "提示的文本 4", answers: [], image: null },
      { id: "q5", question: "提示的文本 5", answers: [], image: null },
    ],
  },
  botId: "nualang.open-ended.0.0.1",
  botName: "open_ended",
  description: "open_ended_desc",
  difficulty: "ALL",
  learnLang: "chinese",
  name: "",
  botAvatar: "",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-comment-dots?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# 欢迎

说 "你好" 来开始。`,
  voice: "",
  versionQuestion: "你想在这个模板中有多少个提示？",
};

export default openEnded;
